__turbopack_context__.v({
  "container": "SalesStartSoonPanel-module-scss-module__bzM4fW__container",
  "content": "SalesStartSoonPanel-module-scss-module__bzM4fW__content",
  "ctaButtonWrapper": "SalesStartSoonPanel-module-scss-module__bzM4fW__ctaButtonWrapper",
  "detailsLoadingSkeleton": "SalesStartSoonPanel-module-scss-module__bzM4fW__detailsLoadingSkeleton",
  "label": "SalesStartSoonPanel-module-scss-module__bzM4fW__label",
});
